import { MuralPost } from 'modules/jogador/mural/types';

export const MURAL_TABS = [
  { value: 'rachas', label: 'Rachas' },
  { value: 'avisos', label: 'Avisos' },
  { value: 'meu-nivel', label: 'Meu nível' },
] as const;

export const MURAL_POSTS: MuralPost[] = [
  {
    id: 'racha-marina',
    kind: 'racha',
    authorName: 'Marina L.',
    timeAgoLabel: 'há 12 min',
    levelLabel: 'nível B',
    text: 'Futevôlei hoje 19h, falta 1 pra fechar. Nível B/B+, R$ 25 por cabeça.',
    courtInfo: 'Areia 3 · 19:00',
    spotsLabel: '3/4',
    courtReserved: true,
    priceLabel: 'R$ 25',
    commentCount: 4,
  },
  {
    id: 'aviso-arena',
    kind: 'aviso',
    authorName: 'Arena Praia Norte',
    isOfficial: true,
    timeAgoLabel: 'há 2h',
    text: 'Areia 1 em manutenção sábado das 6h às 10h. As reservas do período foram remarcadas automaticamente e os valores já pagos estão garantidos no novo horário.',
  },
  {
    id: 'sem-quadra-diego',
    kind: 'sem-quadra',
    authorName: 'Diego C.',
    timeAgoLabel: 'ontem',
    levelLabel: 'nível C',
    text: 'Pickleball domingo de manhã? Se juntar 4, eu reservo a quadra e divido no app.',
    interestedLabel: '2/4 interessados',
  },
];
